import type { FC } from "react";
import type { NavigationBreadcrumbs as NavigationBreadcrumbsProps } from "@motain/xpa-proto-files-web/lib/types/navigation_breadcrumbs";
import styles from "./NavigationBreadCrumbs.module.scss";
import Link from "next/link";
import classnames from "classnames";

export const NavigationBreadCrumbs: FC<NavigationBreadcrumbsProps> = (
  props,
) => {
  const { links, titleA11y } = props;

  return (
    <nav aria-label={titleA11y} className={styles.container}>
      <ul className={styles.links}>
        {links.map((link, index) => {
          const isLastLink = index === links.length - 1;
          return (
            <li key={link.name}>
              {isLastLink ? (
                <span className={classnames("title-8-bold", styles.activePath)}>
                  {link.name}
                </span>
              ) : (
                <Link
                  href={link.urlPath}
                  className={classnames("title-8-regular", styles.link)}
                >
                  {link.name}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
